import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiClientError } from '@/lib/api-client';

import { createRole, listPermissions, listRoles, updateRole } from './api';
import type { PermissionDto, RoleCreateInput, RoleDto, RoleUpdateInput } from './types';

const ROLES_KEY = 'roles' as const;
const PERMISSIONS_KEY = 'permissions' as const;

export const useRolesList = () => {
  return useQuery<RoleDto[], ApiClientError>({
    queryKey: [ROLES_KEY, 'list'],
    queryFn: listRoles,
    placeholderData: (prev) => prev,
  });
};

export const usePermissionsList = () => {
  return useQuery<PermissionDto[], ApiClientError>({
    queryKey: [PERMISSIONS_KEY, 'list'],
    queryFn: listPermissions,
    placeholderData: (prev) => prev,
  });
};

export const useCreateRole = () => {
  const qc = useQueryClient();
  return useMutation<RoleDto, ApiClientError, RoleCreateInput>({
    mutationFn: createRole,
    onSuccess: () => qc.invalidateQueries({ queryKey: [ROLES_KEY] }),
  });
};

export const useUpdateRole = () => {
  const qc = useQueryClient();
  return useMutation<RoleDto, ApiClientError, { roleCode: string; body: RoleUpdateInput }>({
    mutationFn: ({ roleCode, body }) => updateRole(roleCode, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ROLES_KEY] }),
  });
};
